import { Facebook, Instagram, Linkedin, Twitter, Youtube, Music2 } from "lucide-react";

/**
 * Renders a compact row of clickable social profile icons.
 * Accepts a `links` object shaped like:
 *   { facebook, instagram, linkedin, twitter, youtube, tiktok }
 * Missing/empty values are silently skipped.
 */
const CONFIG = [
  { key: "facebook",  label: "Facebook",  Icon: Facebook,  color: "text-[#1877F2]" },
  { key: "instagram", label: "Instagram", Icon: Instagram, color: "text-[#E4405F]" },
  { key: "linkedin",  label: "LinkedIn",  Icon: Linkedin,  color: "text-[#0A66C2]" },
  { key: "twitter",   label: "X (Twitter)", Icon: Twitter, color: "text-slate-800" },
  { key: "youtube",   label: "YouTube",   Icon: Youtube,   color: "text-[#FF0000]" },
  { key: "tiktok",    label: "TikTok",    Icon: Music2,    color: "text-slate-900" },
];

export default function SocialLinks({ links, size = 14, className = "" }) {
  if (!links || typeof links !== "object") return null;
  const items = CONFIG.filter((c) => !!links[c.key]);
  if (items.length === 0) return null;
  return (
    <div className={`inline-flex items-center gap-1.5 ${className}`} data-testid="social-links">
      {items.map(({ key, label, Icon, color }) => (
        <a
          key={key}
          href={links[key]}
          target="_blank"
          rel="noopener noreferrer"
          title={label}
          aria-label={label}
          onClick={(e) => e.stopPropagation()}
          className={`inline-flex items-center justify-center rounded-full hover:bg-slate-100 p-1 transition ${color}`}
          data-testid={`social-${key}`}
        >
          <Icon style={{ width: size, height: size }} />
        </a>
      ))}
    </div>
  );
}
